module.exports = __webpack_public_path__ + "img/icon_db_5.a1dc9cf4.svg";